
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Pregunta: Pregunta;

    }
